import { ROUTES_PATH } from 'app/constants/Routes';

import { GamificationChallengeEvent } from './challengeDomain';
import type { PlanExplorationOrigin } from 'app/hooks/usePlanExploration/types';

export type ChallengeActionInput = {
  event?: string;
  user_status?: string;
  userStatus?: string;
};

type InternalDestination = {
  type: 'internal';
  path: string;
};

type ExternalDestination = {
  type: 'external';
  url: string;
};

type ModalDestination = {
  type: 'modal';
  origin: PlanExplorationOrigin;
};

type NoDestination = {
  type: 'none';
};

export type ChallengeStartDestination =
  | InternalDestination
  | ExternalDestination
  | ModalDestination
  | NoDestination;

const PLAN_RENEWED_EVENT = 'plan_renewed';

const CHALLENGE_EVENT_ROUTE_MAP: Record<string, string> = {
  jussign_doc_created: '/assinaturas/form',
  subuser_created: '/usuarios',
  juscalc_calculation: '/calculadoras',
  jusgpt_chat_started: '/gpt',
  jusmatch_unlock: '/oportunidades',
  jusfinder_search: '/jusfinder/query',
  juspage_access: '/page',
  payment_link_created: ROUTES_PATH.JUSFYPAY.CHARGES,
  payment_successful: ROUTES_PATH.JUSFYPAY.CHARGES,
  recurring_payment_approved: ROUTES_PATH.JUSFYPAY.CHARGES,
  profile_picture_uploaded: ROUTES_PATH.SETTINGS.PERFIL,
  office_defaults_configured: ROUTES_PATH.RELATORIO.EDITAR,
  oab_registered: ROUTES_PATH.ONBOARDING.OAB,
  customer_created: ROUTES_PATH.CLIENTES.CLIENTES,
  jus_contabilidade_purchase_completed: ROUTES_PATH.CONTABILIDADE.LANDING_PAGE,
  ia_personalizada_purchase_completed: ROUTES_PATH.MAIN.GPT_BUSINESS,
};

export const isChallengeBlockedForAction = (
  challenge: ChallengeActionInput,
): boolean => {
  const userStatus = challenge.user_status ?? challenge.userStatus;
  // Concluídos só continuam acionáveis no caso infinito de referral.
  return (
    userStatus === 'finished' &&
    challenge.event !== GamificationChallengeEvent.MEMBER_GET_MEMBER
  );
};

export const shouldOpenInviteModal = (
  challenge: ChallengeActionInput,
): boolean => challenge.event === GamificationChallengeEvent.MEMBER_GET_MEMBER;

export const resolveChallengeStartDestination = (
  event?: string,
): ChallengeStartDestination => {
  if (!event) return { type: 'none' };

  // Alguns desafios levam para recursos externos, sem navegação interna.
  if (['jusfy_training_session', 'jusfy_training_satisfaction'].includes(event)) {
    return {
      type: 'external',
      url: 'https://help.jusfy.com.br/aprenda-a-usar-jusfy-e-acelere-sua-advocacia-jusfy',
    };
  }

  if (event === 'google_review') {
    return {
      type: 'external',
      url: 'https://47445192.hs-sites.com/conclus%C3%A3o-de-desafio',
    };
  }

  if (event === 'community_accessed') {
    return {
      type: 'external',
      url: ROUTES_PATH.EXTERNAL.COMUNIDADE,
    };
  }

  if (event === PLAN_RENEWED_EVENT) {
    return { type: 'modal', origin: 'gamification_challenge' };
  }

  const internalPath = CHALLENGE_EVENT_ROUTE_MAP[event];

  if (internalPath) {
    return {
      type: 'internal',
      path: internalPath,
    };
  }

  return { type: 'none' };
};
